module.exports = __webpack_public_path__ + "static/media/question-circle.1b426fe2.svg";